import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Row.css';

const base_url = "https://image.tmdb.org/t/p/original/";

function Row({ title, fetchUrl, onOpenModal }) {
  const [movies, setMovies] = useState([]);
  const rowRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const request = await axios.get(fetchUrl);
        setMovies(request.data.results);
      } catch (error) {
        console.error("Erro ao carregar filmes da Row:", title, error);
      }
    }
    fetchData();
  }, [fetchUrl, title]);

  const handleScroll = (direction) => {
    if (rowRef.current) {
      const { scrollLeft, clientWidth } = rowRef.current;
      const scrollTo = direction === 'left' 
        ? scrollLeft - clientWidth 
        : scrollLeft + clientWidth;
      rowRef.current.scrollTo({ left: scrollTo, behavior: 'smooth' });
    }
  };

  return (
    <div className="row">
      <h2>{title}</h2>
      <div className="row__container">
        <button className="row__arrow left" onClick={() => handleScroll('left')}>‹</button>
        
        <div className="row__posters" ref={rowRef}>
          {movies?.map((movie) => (
            (movie.poster_path || movie.backdrop_path) && (
              <img
                key={movie.id}
                onClick={() => onOpenModal(movie)}
                className="row__poster"
                src={`${base_url}${movie.poster_path || movie.backdrop_path}`}
                alt={movie.name || movie.title}
              />
            )
          ))}
        </div>

        <button className="row__arrow right" onClick={() => handleScroll('right')}>›</button>
      </div>
    </div>
  );
}

export default Row;
